import React from "react";
import NoRecord from "../../components/table/NoRecord";
import { connect } from "react-redux";
import Tabel from "../../components/table/Table";
import Cancel from "../../assets/images/cancel.svg";
import Grid from "../../utility/Grid/openWithoutFilter";
import Pen from "../../assets/images/pen.svg";
import Tick from "../../assets/images/tick.svg";
import Axe from "../../assets/images/axe.svg";
import Edit from "../../assets/images/pencil.svg";
import Form from "../../utility/Form";
import B2BBookingStatus from "../../components/form-controls/DropDowns/B2BBookingStatus";
import { bgColors } from "../../utility/constants";
import { getUTCDateTime, round } from "../../utility/formatter";
import Mail from "../../assets/images/mail.svg";
import Tooltip from "../../components/form-controls/Tooltip";
import RequestFactory from "../../utility/requestFactory";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import moment_tz from "moment-timezone";
import AccessControl from "../../components/access-control";
import { ls } from "../../utility/localStorage";
import PropTypes from "prop-types";
import Loader from "../../components/loader";
import { getB2BBookingStatus } from "../tripList/B2BTriplist/Action";
import "../tripList/B2BTriplist/B2BTriplist.scss";
import NotificationTypeDD from "../../components/form-controls/DropDowns/NotificationTypeDD";

// Badge under the booking id; aggregator (MMT/EMT/Mojobox) rows have none.
const bookingForBadges = {
  savaari: { label: "Savaari", bg: "#fff6e5", color: "#b26a00" },
  demand_partner: { label: "DP", bg: "#e8f1ff", color: "#1a5fb4" },
  taxida: { label: "Website", bg: "#e9f7ef", color: "#1e7b45" },
  corporate: { label: "Corporate", bg: "#f3ecfb", color: "#6b3fa0" },
};

class NotificationPopupNew extends React.Component {
  constructor(props) {
    super(props);
    this.handleEnquiriesEvent = this.handleEnquiriesEvent.bind(this);
    this.fetchUpdatedData = this.fetchUpdatedData.bind(this);

    this.userId = null;
    let { id: userId, roleId } = JSON.parse(
      ls.getItem("authorizedUserDetails")
    );
    // add default filter for Affiliate Driver, Aff agent and buisness user
    if ([7, 4, 6].includes(roleId)) {
      this.userId = userId;
    }

    // this.table = null;
    this.state = { ...this.initialState(), userRole: roleId };
    // get default filter if available from router
    const filterStatus = ((this.props.location || {}).state || {}).filterStatus;
    // create Grid object
    this.grid = Grid.getInstance({
      currentComponent: this,
      url: "v3/cp/bookings/aggregator/action_needed/trips",
      actionType: "GET_NOTIFICATION_LIST",
      service: "trnzOpenApi",
    });
    // create Form instance
    this.form = Form.getInstance(this, {
      bookingId: "required",
    });
  }
  // payload
  fieldsPayload = {
    status: "", // state for updating status
    bookingIds: [],
    checkedBookings: [],
    notificationType: "",
  };
  initialState(resetToDate) {
    const {
      notificationListFilters: {
        fromDate,
        toDate,
        bookingType,
        aggregatorId,
        bookingFor,
        operatingAreaId,
        vehicleTypeId,
        notificationType,
      },
    } = this.props;
    return {
      filters: {
        commonFilter: "",

        notificationType: resetToDate ? "" : notificationType,
      },
      fields: JSON.parse(JSON.stringify(this.fieldsPayload)),

      bookingId: "",

      aggregatorId: "",
    };
  }

  resetFilter = () => {
    const { notificationListFilters } = this.props;

    this.props.dispatch({
      type: "QUEUE_LIST_FILTERS",
      payload: {
        ...notificationListFilters,

        notificationType: "",
      },
    });
    this.setState(JSON.parse(JSON.stringify(this.initialState(true))), () => {
      this.grid.getRecords();
    });
  };

  handleDateFilterSearch = (e) => {
    this.grid.getRecords();
  };

  editStatus = (id, bookingId, status) => () => {
    this.setState({
      editBookingId: id,
      fields: { ...this.state.fields, status },
    });
  };
  cancelStatus = (id) => () => {
    this.setState({
      editBookingId: !id,
      fields: { ...this.state.fields },
    });
  };

  handleEnquiriesEvent = (event) => {
    if (event.detail) {
      this.fetchUpdatedData();
    }
  };
  fetchUpdatedData() {
    this.grid.getRecords();
  }

  componentDidMount() {
    console.log("Adding event listener for 'eventName'");
    window.addEventListener("eventName", this.handleEnquiriesEvent);
    this.grid.getRecords();
  }
  componentWillUnmount() {
    console.log("Removing event listener for 'eventName'");
    window.removeEventListener("eventName", this.handleEnquiriesEvent);
  }

  componentDidUpdate(prevProps) {
    const { notificationList } = this.props;
    const count =
      notificationList && notificationList.response
        ? notificationList.response.count
        : undefined;
    const prevCount =
      prevProps.notificationList && prevProps.notificationList.response
        ? prevProps.notificationList.response.count
        : undefined;

    if (count !== undefined && prevCount !== undefined && count !== prevCount) {
      this.props.onCountChange(count);
    }
  }

  updateBookingStatus = () => {
    const {
      fields: { status },
      editBookingId,
    } = this.state;
    this.setState(
      {
        showMultiAssignPopup: false,
        showAssignPopup: false,
        showSelectedBookingsPopup: false,
      },
      () => {
        RequestFactory.setHeaders("Content-Type", "application/json")
          .withRequestBodyType("Json")
          .patch(
            `v1/corporate-booking/bookings/${editBookingId}/${status}`,
            {},
            (response) => {
              if (response.status === 204) {
                toast.success("Trip updated successfully.");
                this.setState({
                  editBookingId: "",
                });
                this.grid.getRecords();
              }
            },
            () => {
              toast.error("Something went wrong, please try again.");
            }
          );
      }
    );
  };

  getTableRows = () => {
    const {
      notificationList: {
        response: { bookings: notificationList },
        isFetching,
      },
      b2bBookingStatus: { response: b2bBookingStatus },
    } = this.props;
    const notificationColorClass = {
      "Driver Not Assigned": "text-red",
      "Driver Not Enroute to Pickup": "text-orange",
      "Driver Not Arrived": "text-purple",
      "Customer Not Boarded": "text-navy",
      "Trip Action Required": "text-green",
    };
    const formatText = (text) => {
      if (text == null) {
        return "";
      }
      return text
        .split(/(?=[A-Z])/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };
    const { editBookingId, fields, userRole } = this.state;
    return isFetching ? (
      <tr>
        <td colSpan="11">
          <Loader />
        </td>
      </tr>
    ) : !notificationList || !notificationList.length ? (
      <NoRecord colSpan="11" />
    ) : (
      notificationList.map((t, index) => {
        const bookingType =
          t.bookingType === "outstation" && t.returnDateAndTime
            ? "Outstation - Round"
            : t.bookingType === "outstation"
              ? "Outstation - Oneway"
              : formatText(t.bookingType) || "-";

        return (
          <React.Fragment key={index}>
            <tr
              className={
                bookingType === "Outstation - Oneway" ||
                  bookingType === "Outstation - Round"
                  ? "trip-body-out device-type"
                  : "trip-body device-type"
              }
            >
              <td className="bg-id">
                <div className="starr">
                  <div className="star-id">{t.bookingId || "-"}</div>
                  {bookingForBadges[t.bookingFor] ? (
                    <span
                      style={{
                        display: "inline-block",
                        marginTop: "4px",
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontSize: "11px",
                        fontWeight: 600,
                        backgroundColor: bookingForBadges[t.bookingFor].bg,
                        color: bookingForBadges[t.bookingFor].color,
                      }}
                    >
                      {bookingForBadges[t.bookingFor].label}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </td>

              <td
                className={`bg-id-1 ${notificationColorClass[t.notificationType]}`}
              >

                {t.notificationType || "-"}
              </td>
              <td className="tp-width-1">
                {t.operatorPhone ? (
                  <>
                    <div className="popup-v">
                      <h5> Operator details</h5>

                      <div className="cust-details">
                        <div className="cust-n">
                          <p className="pg-1">Name</p>
                          <p className="pg-2">:</p>
                          <p className="pg-3">{t.operatorName || "-"}</p>
                        </div>
                        <div className="cust-n">
                          <p className="pg-1"> Phone</p>
                          <p className="pg-2">:</p>
                          <p className="pg-3">{t.operatorPhone || "-"}</p>
                        </div>

                      </div>
                    </div>

                  </>
                ) : ("")}
                {t.vendorPhone ? (
                  <>
                    <div className="popup-v">
                      <h5> Vendor details</h5>

                      <div className="cust-details">
                        <div className="cust-n">
                          <p className="pg-1">Name</p>
                          <p className="pg-2">:</p>
                          <p className="pg-3">{t.vendorName || "-"}</p>
                        </div>
                        <div className="cust-n">
                          <p className="pg-1"> Phone</p>
                          <p className="pg-2">:</p>
                          <p className="pg-3">{t.vendorPhone || "-"}</p>
                        </div>

                      </div>
                    </div>

                  </>
                ) : ("")}
              </td>
              <td>{t.regionName || "-"}</td>
              <td>{getUTCDateTime(t.travelDateTime)}</td>
              <td className="bg-action">
                {userRole === 6 &&
                  moment_tz().tz("Asia/Kolkata").format() >=
                  moment(t.travelDateTime).add(-4, "hour").utc().format() ? (
                  ""
                ) : (
                  <AccessControl section={"bookings.edit"}>
                    {/* <Link
                      to={`/b2bbookings/add/${t.id}`}
                      type="button"
                      className="trip-btn action-btn list-icon-pad"
                      title="Edit booking"
                    >
                      <img src={Pen} alt="pen" />
                    </Link> */}

                    <a
                      href={`/b2bbookings/add/${t.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      type="button"
                      className="trip-btn action-btn list-icon-pad"
                      title="Edit booking"
                    >
                      <img src={Pen} alt="pen" />
                    </a>

                  </AccessControl>
                )}

                <button
                  style={{ display: "none" }}
                  type="submit"
                  ref={(n) => (this.submitButton = n)}
                ></button>
              </td>
            </tr>
          </React.Fragment>
        );
      })
    );
  };

  handleFilterChange = (e) => {
    const {
      target: { value },
      which,
      keycode,
      preventDefault,
    } = e;
    this.setState(
      {
        filters: {
          ...this.state.filters,
          fromDate: value ? "" : moment().format("DD-MM-YYYY"),
          toDate: value ? "" : moment().format("DD-MM-YYYY"),
        },
      }, // filter after resetting dates
      () => {
        this.grid.handleColFiltersKeyDown({
          keycode,
          which,
          preventDefault,
        });
      }
    );
  };

  // Funtion to maintain filters in state
  handleDateFiltersChange = (name, date) => {
    const { notificationListFilters } = this.props;
    this.props.dispatch({
      type: "QUEUE_LIST_FILTERS",
      payload: {
        ...notificationListFilters,
        [name]: date.format("DD-MM-YYYY"),
      },
    });
    this.setState({
      filters: { ...this.state.filters, [name]: date.format("DD-MM-YYYY") },
    });
  };
  handleFiltersChange = (name, value) => {
    const { notificationListFilters } = this.props;
    this.props.dispatch({
      type: "QUEUE_LIST_FILTERS",
      payload: { ...notificationListFilters, [name]: value },
    });
    this.setState({
      filters: { ...this.state.filters, [name]: value },
    });
  };

  render() {
    const {
      filters,
      showAssignPopup,
      fields,
      multipleSelectError,
      showMultiAssignPopup,
      showSelectedBookingsPopup,
    } = this.state;
    const { showing, close } = this.props;
    const {
      notificationList,
      notificationList: {
        response: { count },
      },
    } = this.props;
    return (
      <div
        className="modal modal-1 "
        style={{
          display: showing ? "block" : "none",
        }}
      >
        <div className="modal-dialog-1">
          <div className="modal-content driver-pad-1">

            <div className="container-trip-out-1">

              <div className="container-trip queue-list-1">
                <div>
                  <div className="trip-row">
                    <div className="col-sd-12 col-xs-12 trip-pad">
                      <div className="nav-flex nav-search-flex">
                        <div className="flex-all">
                          <h1 className="trip">
                            Trip attention required ({count || 0})
                          </h1>
                        </div>
                        <div className="nav-book-filter nav-search-filter">
                          <div className="five-width-nav">
                            {/*<span className="trip-select select-display notifi-select">
                                  <NotificationTypeDD
                                    name="f_notificationType"
                                    // onChange={this.grid.handleColFiltersChange}
                                    onChange={(event) =>
                                      this.handleFiltersChange(
                                        "notificationType",
                                        event.target.value
                                      )
                                    }
                                    value={filters.notificationType}
                                  />
                                </span>*/}
                          </div>
                        </div>

                        <div className="nav-btn">
                          <button
                            type="button"
                            className="date-btn yellow-apply"
                            title="Search"
                            onClick={this.handleDateFilterSearch}
                          >
                            Apply
                          </button>
                          <button
                            type="button"
                            className="date-btn"
                            title="Reset"
                            onClick={this.resetFilter}
                          >
                            Reset
                          </button>
                          <img
                            onClick={close}
                            src={Cancel}
                            alt="pick-drop"
                            className="close-btn-hot-1"
                          />
                        </div>
                      </div>
                    </div>

                    <Tabel
                      ref={(node) => {
                        this.table = node;
                      }}
                      data={notificationList}
                      rowStatus={this.props.tripListStatus}
                      grid={this.grid}
                    >
                      <div className="col-sd-12 trip-table">
                        <div className="table-responsive">
                          <table id="customers" className="triplist">
                            <thead className="thead">
                              <tr className="trip-head">
                                <th className="bg-id ">Booking ID</th>
                                <th className="bg-id-1 ">Status</th>
                                <th className="tp-width-1">Operator / <br />
                                  Vendor details </th>
                                <th>Operating area name</th>

                                <th>Travel date/time</th>
                                <AccessControl section={["bookings.edit"]}>
                                  <th className="bg-action">Action</th>
                                </AccessControl>
                              </tr>
                            </thead>
                            <tbody className="trip-height">
                              {this.getTableRows()}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Tabel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    );
  }
}
NotificationPopupNew.propTypes = {
  notificationList: PropTypes.object.isRequired,
};
export default connect(
  ({ notificationList, notificationListFilters, b2bBookingStatus }) => ({
    notificationList,
    notificationListFilters,
    b2bBookingStatus,
  })
)(NotificationPopupNew);
